import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import config from "configs/config";
import apiClient from "lib/api-client";

//--------------- Save Limits ------------------------\\

export const createLimits = async (payload) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/limit/create`, payload);
  return response.data;
};

//--------------- Get Limits -----------------------\\

export const getLimits = async (userId) => {
  let response = await apiClient.get(`${config.baseUrl}/api/v1/limit/get-limit/${userId}`);
  return response.data;
};

//-------------- Get My Binnys Client Limit ------\\\\

export const getMyBinnysClientLimits = async (clientIds) => {
  let response = await apiClient.post(`${config.baseUrl}/api/v1/limit//get-mybinnys-limit`, { clientIds });
  return response.data;
};

// http://localhost:8000/api/v1/limit/get-limit/67051b8b6f5a3f68cc04898b

// ---------------------------------- All User Limit ------------------------------------ \\

const fetchUserLimits = async ({ queryKey }) => {
  const [_key, params] = queryKey;

  const res = await apiClient.post("/api/v1/limit/getAllUserLimit", {
    search: params.search || "",
    sortBy: params.sortBy || "userName",
    order: params.order || "asc",
  });

  return res.data.data;
};

export const useUserLimits = ({ isRole, search = "", sortBy = "userName", order = "asc" }) => {
  return useQuery({
    queryKey: ["userLimits", { search, sortBy, order }],
    queryFn: fetchUserLimits,
    enabled: !!isRole,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};

// ---------------------------------- Update limit ----------------------------------------- \\

const updateUserLimit = async (payload) => {
  const res = await apiClient.put("/api/v1/limit/updateUserLimit", payload);
  return res.data;
};

export const useUpdateUserLimit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserLimit,
    onSuccess: () => {
      queryClient.invalidateQueries(["userLimits"]);
    },
  });
};

// ---------------------------------- Linit by Client -------------------------------------------\\

const fetchClientLimits = async ({ queryKey }) => {
  const [_key, params] = queryKey;

  const res = await apiClient.post("/api/v1/limit/getMyBinnysClientLimitData", {
    searchTerm: params.search || "",
    sortBy: params.sortBy,
    order: params.order || "asc",
  });
  return res.data.data.clients;
};

export const useClientLimits = ({ isRole, search = "", sortBy = "Client Name", order = "asc", limit = 12, page = 1 }) => {
  return useQuery({
    queryKey: ["userLimits", { search, sortBy, order }],
    queryFn: fetchClientLimits,
    enabled: !isRole,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};

// Update client

const updateClientLimit = async (payload) => {
  const res = await apiClient.put("/api/v1/limit/updateMyBinnysClientLimitData", payload);

  return res.data;
};

export const useUpdateClientLimit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateClientLimit,
    onSuccess: () => {
      queryClient.invalidateQueries(["clientLimits"]);
    },
  });
};
